import type { IconData } from '@stacksjs/iconify-core'

export const tz4x3: IconData = {
  "body": "<defs><clipPath id=\"SVGCUqt9dOZ\"><path fill-opacity=\".7\" d=\"M10 0h160v120H10z\"/></clipPath></defs><g fill-rule=\"evenodd\" stroke-width=\"1pt\" clip-path=\"url(#SVGCUqt9dOZ)\" transform=\"matrix(4 0 0 4 -40 0)\"><path fill=\"#09f\" d=\"M0 0h180v120H0z\"/><path fill=\"#090\" d=\"M0 0h180L0 120z\"/><path fill=\"#000001\" d=\"M0 120h40l140-95V0h-40L0 95z\"/><path fill=\"#ff0\" d=\"M0 91.5L137.2 0h13.5L0 100.5zM29.3 120L180 19.5v9L42.8 120z\"/></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default tz4x3
